import Styles from "./Update.module.scss";
import clsx from "clsx";
import useUpdateProfile from "../../../Hooks/useUpdateProfile";
import { Input } from "../../../Components/Atoms/Input";
import { DateInput } from "../../../Components/Atoms/DateInput";
import { Controller } from "react-hook-form";
import ReCaptcha from "../../../Components/Molecules/ReCaptcha";

function UpdateProfile() {
  const {
    control,
    handleSubmit,
    isSentPhoneVerify,
    isSendingPhoneVerify,
    handleGetPhoneVerifyCode,
    isFormDisabled,
    pageLoading,
    version,
    reCaptchaV2,
    isLoadReCaptChaV3,
    recaptchaLoading,
    recaptchaError,
    isDefaultV3,
    loading,
  } = useUpdateProfile();

  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.contentMain)}>
        <div className={clsx(Styles.contentCenter)}>
          <div className={clsx(Styles.iframeId)}>
            <div className={clsx(Styles.wrapIframe)}>
              <div className={clsx(Styles.form)}>
                <form onSubmit={handleSubmit} method="post" action="">
                  <h2>Cập nhật thông tin</h2>
                  <div className={clsx(Styles.hr)}></div>
                  <Controller
                    name="userName"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Input
                        label="Tài Khoản *"
                        id="userName"
                        placeholder="Độ dài từ 6 đến 24 ký tự. Sử dụng các ký tự: a-z, 0-9"
                        value={field.value}
                        onChange={(e) => {
                          var value = e.target.value;
                          field.onChange(value.toLowerCase());
                        }}
                        error={error}
                        isDisable={true}
                      />
                    )}
                  />

                  <Controller
                    name="fullName"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Input
                        label="Họ và tên *"
                        id="fullName"
                        value={field.value}
                        onChange={field.onChange}
                        error={error}
                        isDisable={pageLoading}
                      />
                    )}
                  />

                  <div className={clsx(Styles.phoneGroup)}>
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <div className={clsx(Styles.phoneInput)}>
                          <Input
                            label="Số điện thoại"
                            id="phone"
                            value={field.value}
                            onChange={field.onChange}
                            error={error}
                            isDisable={pageLoading}
                          />
                        </div>
                      )}
                    />

                    <Controller
                      name="phoneOtp"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <div className={clsx(Styles.phoneOtpInput)}>
                          <Input
                            label="OTP"
                            id="phoneOtp"
                            value={field.value}
                            onChange={field.onChange}
                            error={error}
                            isDisable={pageLoading}
                          />
                        </div>
                      )}
                    />

                    <button
                      type="button"
                      onClick={handleGetPhoneVerifyCode}
                      className={clsx(Styles.getCodeBtn)}
                      disabled={
                        pageLoading ||
                        loading ||
                        isSentPhoneVerify ||
                        isSendingPhoneVerify
                      }
                    >
                      {isSendingPhoneVerify
                        ? "Đang gửi..."
                        : isSentPhoneVerify
                          ? "Đã gửi"
                          : "Lấy OTP"}
                    </button>
                  </div>

                  <div className={clsx(Styles.recaptchaWrapper)}>
                    <ReCaptcha
                      version={version}
                      isDefaultV3={isDefaultV3}
                      reCaptchaV2={reCaptchaV2}
                      recaptchaLoading={recaptchaLoading}
                      recaptchaError={recaptchaError}
                      isLoadReCaptChaV3={isLoadReCaptChaV3}
                    />
                  </div>

                  <Controller
                    name="dateOfBirth"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <DateInput
                        label="Ngày sinh"
                        id="dateOfBirth"
                        value={field.value}
                        onChange={field.onChange}
                        error={error}
                        isDisable={pageLoading}
                      />
                    )}
                  />

                  <Controller
                    name="password"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Input
                        label="Xác nhận mật khẩu *"
                        id="password"
                        type="password"
                        value={field.value}
                        onChange={field.onChange}
                        error={error}
                        isDisable={pageLoading}
                      />
                    )}
                  />

                  <div className={clsx(Styles.formGroup)}>
                    <button
                      className={clsx(Styles.btn, {
                        [Styles.disabled]: isFormDisabled,
                      })}
                      type="submit"
                      disabled={isFormDisabled}
                    >
                      {pageLoading
                        ? "Đang tải thông tin..."
                        : loading
                          ? "Đang cập nhật..."
                          : "Cập nhật"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default UpdateProfile;
